import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import AuthModal from './AuthModal';

function initialsFor(user) {
  const name = user.displayName || user.email || '';
  const parts = name.trim().split(/\s+|@/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export default function UserBadge() {
  const { user, loading, signOut } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const wrapRef = useRef();

  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  if (loading) return <div style={{ width: 80 }} aria-hidden="true" />;

  if (!user) {
    return (
      <>
        <button className="signin-btn" onClick={() => setShowAuth(true)}>Sign in</button>
        {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
      </>
    );
  }

  const displayName = user.displayName || user.email?.split('@')[0] || 'Account';

  return (
    <div className="user-menu-wrap" ref={wrapRef}>
      <button className="user-badge" onClick={() => setMenuOpen((o) => !o)} aria-haspopup="menu" aria-expanded={menuOpen}>
        <span className="user-badge-avatar">
          {user.photoURL ? <img src={user.photoURL} alt="" referrerPolicy="no-referrer" /> : initialsFor(user)}
        </span>
        <span className="user-badge-name">{displayName}</span>
      </button>
      {menuOpen && (
        <div className="user-menu" role="menu">
          <div className="user-menu-header">
            <div className="user-menu-email" title={user.email || ''}>{user.email || displayName}</div>
          </div>
          <button className="user-menu-item danger" onClick={async () => { await signOut(); setMenuOpen(false); }}>
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
